import { render, staticRenderFns } from "./AlTooltipBtn.vue?vue&type=template&id=ec499b02&"
import script from "./AlTooltipBtn.vue?vue&type=script&lang=ts&"
export * from "./AlTooltipBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AlTooltipBtn.vue?vue&type=style&index=0&id=ec499b02&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports